// extracted by mini-css-extract-plugin
export var icon = "J_f";
export var iconBlue = "J_cb";
export var iconDark = "J_cf";
export var iconMono = "J_cc";
export var iconWhite = "J_cd";
export var line = "J_b9";
export var logo = "J_b8";
export var name = "J_ch";
export var prefix = "J_cg";